import React from 'react';
import Icon from '../Icon/Icon';
import styles from './Intro.module.css';

/**
 * Intro Component - ¿Qué es TECNILAND?
 * DESKTOP-FIRST: Optimizado para 1920px+
 * CSS Module para aislamiento de estilos
 */
function Intro() {
  return (
    <section id="intro" className={styles.intro}>
      <div className={styles.introContainer}>
        <h2 className={styles.introTitle}>¿Qué es <span translate="no" className="notranslate">TECNILAND</span>?</h2>
        <p className={styles.introText}>
          <span translate="no" className="notranslate">TECNILAND</span> nació en 2020 como un simple servidor para jugar con amigos. Un nombre improvisado, inspirado por series de rol como <span translate="no">Karmaland</span>, pero que terminó convirtiéndose en algo mucho más grande. 
          Lo que empezó como una idea casual hoy es un proyecto que quiero convertir en marca, en universo y en experiencia.
        </p>

        <div className={styles.features}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <Icon name="launcher" size="xl" animation="pulse" />
            </div>
            <h3><span lang="en">Launcher</span> Nexus</h3>
            <p>Gestor inteligente de modpacks con actualizaciones automáticas *Basado en HeliosLauncher* </p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <Icon name="world" size="xl" animation="float" />
            </div>
            <h3>Modpacks Épicos</h3>
            <p>Experiencias temáticas únicas con worldbuilding inmersivo</p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <Icon name="lore" size="xl" animation="float" />
            </div>
            <h3>Lore Profundo</h3>
            <p>Narrativa compleja con personajes, misiones y mundos interconectados</p>
          </div>

          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <Icon name="phase-beta" size="xl" animation="bounce" />
            </div>
            <h3>Comunidad</h3>
            <p>Servidor multiplayer con roles, eventos y reglas bien definidas</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
